// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4541":"c8986a07","5654":"fcef6952","8260":"c5181bb4","8682":"9bbeb000"}[chunkId] + ".chunk.css";
};